import $ from 'jquery';

const videoLazyLoad = () => {
    const init = () => {
        loadChecker();
    }

    // add class active when window loaded
    // will be triggered when windows loaded
    const loadChecker = () => {
        const el = {
            item: '.hero-banner-v2 video',
        }

        if ($(el.item).length === 0) return;

        $(window).on('load', () => {
            setTimeout(() => {
                $(el.item).addClass('ready');
            }, 2000)
        })
    }

    init();
}

export default videoLazyLoad;

